/**
 * Serialize rows into CSV text. Every cell is quoted so titles containing the
 * delimiter, quotes or newlines survive a round-trip through spreadsheets.
 */
export function toCsv(
  header: string[],
  rows: Array<Array<string | number | null | undefined>>,
  delimiter = ";"
): string {
  const escape = (value: string | number | null | undefined) =>
    `"${(value ?? "").toString().replace(/"/g, '""')}"`;
  return [header.map(escape).join(delimiter), ...rows.map((row) => row.map(escape).join(delimiter))].join("\n");
}

/** Trigger a browser download of `csv` as `fileName`. */
export function downloadCsv(csv: string, fileName: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.setAttribute("hidden", "");
  anchor.setAttribute("href", url);
  anchor.setAttribute("download", fileName);
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  if (typeof window.URL.revokeObjectURL === "function") window.URL.revokeObjectURL(url);
}
